import { QSelect } from 'quasar'
import { applySelectDefaults } from 'src/plugins/helpers/select-defaults'

export default () => {
  applySelectDefaults(QSelect)
}
